import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';
import './estilodash.css';

export default function ListarLicencas() {
  const [licencas, setLicencas] = useState([]);
  const [busca, setBusca] = useState('');
  const [produto, setProduto] = useState('todos');
  const [status, setStatus] = useState('ativas');
  const [editandoExpiracaoId, setEditandoExpiracaoId] = useState(null);
  const [novaExpiracao, setNovaExpiracao] = useState('');
  const [salvandoExpiracaoId, setSalvandoExpiracaoId] = useState(null);

  const carregar = async () => {
    const r = await api.get('/api/licencas-v2');
    setLicencas(r.data || []);
  };

  useEffect(() => {
    carregar().catch(console.error);
  }, []);

  const filtradas = useMemo(() => {
    return licencas.filter((l) => {
      const txt = busca.toLowerCase();

      const okBusca =
        !txt ||
        String(l.id || '').toLowerCase().includes(txt) ||
        String(l.conta || '').toLowerCase().includes(txt) ||
        String(l.cliente_nome || '').toLowerCase().includes(txt) ||
        String(l.produto_nome || '').toLowerCase().includes(txt) ||
        String(l.codigo_plano || l.produto_codigo || '').toLowerCase().includes(txt) ||
        String(l.lkey || '').toLowerCase().includes(txt);

      const okProduto =
        produto === 'todos' ||
        String(l.codigo_plano || l.produto_codigo || '').toLowerCase() === produto;

      const okStatus =
        status === 'todos' ||
        (status === 'ativas'
          ? String(l.status) === '1'
          : String(l.status) !== '1');

      return okBusca && okProduto && okStatus;
    });
  }, [licencas, busca, produto, status]);

  const toggleStatus = async (l) => {
    try {
      await api.put(`/api/licencas-v2/${l.id}/status`, {
        status: String(l.status) === '1' ? '0' : '1',
      });
      await carregar();
    } catch (err) {
      console.error('Erro ao alterar status da licenca:', err);
      alert(err.response?.data?.message || 'Erro ao alterar status da licenca.');
    }
  };

  const remover = async (l) => {
    if (!window.confirm('Remover esta licenca?')) return;

    try {
      await api.delete(`/api/licencas-v2/${l.id}`);
      await carregar();
    } catch (err) {
      console.error('Erro ao remover licenca:', err);
      alert(err.response?.data?.message || 'Erro ao remover licenca.');
    }
  };

  const toInputDate = (data) => {
    if (!data) return '';

    const valor = String(data).slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) return valor;

    const d = new Date(data);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  };

  const iniciarEdicaoExpiracao = (licenca) => {
    setEditandoExpiracaoId(licenca.id);
    setNovaExpiracao(toInputDate(licenca.date_exp));
  };

  const cancelarEdicaoExpiracao = () => {
    setEditandoExpiracaoId(null);
    setNovaExpiracao('');
  };

  const salvarExpiracao = async (licenca, dataExpiracao = novaExpiracao) => {
    const dateExp = dataExpiracao || null;
    try {
      setSalvandoExpiracaoId(licenca.id);
      await api.put(`/api/licencas-v2/${licenca.id}/data`, {
        date_exp: dateExp,
      });
      await carregar();
      cancelarEdicaoExpiracao();
    } catch (err) {
      console.error('Erro ao atualizar expiracao da licenca:', err);
      alert(err.response?.data?.message || 'Erro ao atualizar expiracao da licenca.');
    } finally {
      setSalvandoExpiracaoId(null);
    }
  };

  const formatarChave = (chave) => {
    if (!chave) return '-';
    const s = String(chave);
    if (s.length <= 20) return s;
    return `${s.slice(0, 12)}...${s.slice(-8)}`;
  };

  const formatarData = (data) => {
    if (!data) return 'Sem expiracao';
    if (String(data).startsWith('0000-00-00')) return 'Sem expiracao';

    const d = new Date(data);
    if (Number.isNaN(d.getTime())) return data;
    return d.toLocaleDateString('pt-BR');
  };

  return (
    <div className="pagamentos-container">
      <h2>Licencas</h2>

      <div className="qt-filter-panel"
        style={{
          display: 'grid',
          gridTemplateColumns: '2.4fr 1.1fr 1.1fr',
          gap: 12,
          marginBottom: 16,
          alignItems: 'end',
        }}
      >
        <div style={{ width: '100%' }}>
          <label style={{ display: 'block', width: '100%', marginBottom: 0 }}>
            Buscar
          </label>
          <input
            type="text"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            placeholder="Cliente, conta, produto ou chave..."
            style={{ width: '100%' }}
          />
        </div>

        <div style={{ width: '100%' }}>
          <label style={{ display: 'block', width: '100%', marginBottom: 0 }}>
            Produto
          </label>
          <select
            value={produto}
            onChange={(e) => setProduto(e.target.value)}
            style={{ width: '100%' }}
          >
            <option value="todos">Todos</option>
            <option value="ea">EA</option>
            <option value="bias">Bias</option>
            <option value="ragnarok">Ragnarok</option>
          </select>
        </div>

        <div style={{ width: '100%' }}>
          <label style={{ display: 'block', width: '100%', marginBottom: 0 }}>
            Status
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{ width: '100%' }}
          >
            <option value="ativas">Ativas</option>
            <option value="inativas">Inativas</option>
            <option value="todos">Todos</option>
          </select>
        </div>
      </div>

      <table className="clientes-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Cliente</th>
            <th>Produto</th>
            <th>Conta</th>
            <th>Chave</th>
            <th>Tipo</th>
            <th>Status</th>
            <th>Expira</th>
            <th>Acoes</th>
          </tr>
        </thead>

        <tbody>
          {filtradas.map((l) => {
            const ativa = String(l.status) === '1';
            const editandoExpiracao = editandoExpiracaoId === l.id;
            const salvandoExpiracao = salvandoExpiracaoId === l.id;

            return (
              <tr key={l.id}>
                <td>{l.id}</td>
                <td>{l.cliente_nome || l.cliente_id}</td>
                <td>{l.produto_nome || l.codigo_plano || l.produto_codigo || '-'}</td>
                <td>{l.conta || '-'}</td>
                <td title={l.lkey || ''}>{formatarChave(l.lkey)}</td>
                <td>{l.tipo || '-'}</td>
                <td>
                  <span className={ativa ? 'qt-badge qt-badge-success' : 'qt-badge qt-badge-danger'}>
                    {ativa ? 'Ativa' : 'Inativa'}
                  </span>
                </td>
                <td>{formatarData(l.date_exp)}</td>
                <td>
                  <div className="assinatura-acoes">
                    <button
                      type="button"
                      className={`qt-btn assinatura-btn ${
                        ativa
                          ? 'qt-btn-danger assinatura-btn-desativar'
                          : 'qt-btn-success assinatura-btn-ativar'
                      }`}
                      onClick={() => toggleStatus(l)}
                    >
                      {ativa ? 'Desativar' : 'Ativar'}
                    </button>

                    {editandoExpiracao ? (
                      <>
                        <input
                          type="date"
                          value={novaExpiracao}
                          onChange={(e) => setNovaExpiracao(e.target.value)}
                          className="licenca-data-input"
                        />
                        <button
                          type="button"
                          className="qt-btn qt-btn-primary assinatura-btn assinatura-btn-salvar"
                          onClick={() => salvarExpiracao(l)}
                          disabled={salvandoExpiracao}
                        >
                          {salvandoExpiracao ? 'Salvando...' : 'Salvar data'}
                        </button>
                        <button
                          type="button"
                          className="qt-btn qt-btn-neutral assinatura-btn assinatura-btn-cancelar"
                          onClick={() => salvarExpiracao(l, null)}
                          disabled={salvandoExpiracao}
                        >
                          Sem expiracao
                        </button>
                        <button
                          type="button"
                          className="qt-btn qt-btn-neutral assinatura-btn assinatura-btn-cancelar"
                          onClick={cancelarEdicaoExpiracao}
                          disabled={salvandoExpiracao}
                        >
                          Cancelar
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        className="qt-btn qt-btn-warning assinatura-btn assinatura-btn-editar"
                        onClick={() => iniciarEdicaoExpiracao(l)}
                      >
                        Editar expiracao
                      </button>
                    )}

                    <button
                      type="button"
                      className="qt-btn qt-btn-danger assinatura-btn assinatura-btn-remover"
                      onClick={() => remover(l)}
                    >
                      Remover
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}

          {filtradas.length === 0 && (
            <tr>
              <td colSpan="9">Nenhuma licenca encontrada.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
